// offerSlice.js
import { createSlice } from "@reduxjs/toolkit";

export const offerSlice = createSlice({
  name: "offers",
  initialState: {
    data: [],
  },
  reducers: {
    setOffers: (state, action) => {
      state.data = action.payload;
    },
    clearOffers: (state) => {
      state.data = null;
    },
  },
});

export const { setOffers, clearOffers } = offerSlice.actions;
export default offerSlice.reducer;
